import React, { useState,createContext } from "react";

import useLocalStorage from '../Hooks/useLocalStorage'

export const UserIDContext = createContext();
export const UserIDUpdateContext = createContext();
export const UserTypeContext = createContext();
export const UserTypeUpdateContext = createContext();
export const UserLogoutContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [userID, setUserID] = useLocalStorage("muktiUserID",null);
  const [userType, setUserType] = useLocalStorage("muktiUserType",null);
  const updateUserID=(data)=>{
    setUserID(data)
  }
  const updateUserType=(data)=>{
    setUserType(data)
  }
  const userlogout=()=>{
    setUserID(null)
    setUserType(null)
  }
  return (

      <UserLogoutContext.Provider value={userlogout}>
      <UserTypeUpdateContext.Provider value={updateUserType}>
      <UserIDUpdateContext.Provider value={updateUserID}>
      <UserIDContext.Provider value={userID}>
        <UserTypeContext.Provider value={userType}>
            {children}
        </UserTypeContext.Provider>
      </UserIDContext.Provider>
      </UserIDUpdateContext.Provider>
      </UserTypeUpdateContext.Provider>
      </UserLogoutContext.Provider>


  );
};